import React from 'react';
import { Menu } from 'antd';
import { MessageOutlined, WechatOutlined, CarOutlined, LogoutOutlined } from '@ant-design/icons';
import * as Constants from '../../../constants';
import './styles.css';

const MainMenuClient = ({ onItemClick, itemSelected, user }) => {
    return (
        <Menu className="MainMenuCont" theme="dark" defaultSelectedKeys={[itemSelected]} mode="horizontal">
            <Menu.Item key={`/`} onClick={() => {onItemClick({itemClickType: Constants.MenuClient.CHAT})}}>
                <MessageOutlined />
                <span>Chat</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuClient.HISTORICAL_CHAT}`} onClick={() => {onItemClick({itemClickType: Constants.MenuClient.HISTORICAL_CHAT})}}>
                <WechatOutlined />
                <span>Chat - Históricos</span>
            </Menu.Item>
            {
                Constants.UsersWithPermissions.includes(user.email) &&
                    <Menu.Item key={`/${Constants.MenuClient.INVENTORY_HISTORICAL}`} onClick={() => {onItemClick({itemClickType: Constants.MenuClient.INVENTORY_HISTORICAL})}}>
                        <CarOutlined  />
                        <span>Movilidades - Históricos</span>
                    </Menu.Item>
            }
            <Menu.Item key={`/${Constants.MenuClient.LOGOUT}`} onClick={() => {onItemClick({itemClickType: Constants.MenuClient.LOGOUT})}}>
                <LogoutOutlined />
                <span>Cerrar sesión</span>
            </Menu.Item>
        </Menu>
    );
};

MainMenuClient.propTypes = {

};

export default MainMenuClient;
